module.exports = __webpack_public_path__ + "img/yz_1@2x.f87f5175.png";